import React from "react";

const About = () => {
  return (
    <div className="container text-center p-3">
      <h1>MAOS</h1>
      <h2 className="text-capitalize">musical accessories online store</h2>
      <div className="row">
        <div className="col-10 mx-auto about-text muted text-center p-5">
          Located in Israel, Haifa City. The main purpose of our store is to
          give an opportunity for every one to get their used and new equipment
          a new life. We call it an open social sell connection Everyone is
          welcome to put any of your musical device on our platform Just provide
          us a good quality pic, full description and price (don't forget we
          have to add 17% tax for a local customs) All the sells are getting
          done in Israel only. To connect pls send me an email to
          gfalk85@gmail.com or by phone # +972 54 6358158
        </div>
      </div>
    </div>
  );
};

export default About;



// WEBPACK FOOTER //
// ./src/components/About.js